
export const GET_LABELER_SUMMARY = 'GET_LABELER_SUMMARY';
export const GET_LABELER_SUMMARY_SUCCESS = 'GET_LABELER_SUMMARY_SUCCESS';
export const GET_LABELER_SUMMARY_FAILURE = 'GET_LABELER_SUMMARY_FAILURE';

export const GET_TEMPLATES = 'GET_TEMPLATES';
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';
export const GET_TEMPLATES_FAILURE = 'GET_TEMPLATES_FAILURE';
export const GET_LITER_TAX_UUID = 'GET_LITER_TAX_UUID';
export const GET_LITER_TAX_UUID_SUCCESS = 'GET_LITER_TAX_UUID_SUCCESS';
export const GET_LITER_TAX_UUID_FAILURE = 'GET_LITER_TAX_UUID_FAILURE';
export const CLEAR_LABEL_PREVIEW = 'CLEAR_LABEL_PREVIEW';
export const GET_LABEL_PREVIEW = 'GET_LABEL_PREVIEW';
export const GET_LABEL_PREVIEW_SUCCESS = 'GET_LABEL_PREVIEW_SUCCESS';
export const GET_LABEL_PREVIEW_FAILURE = 'GET_LABEL_PREVIEW_FAILURE';

export const SET_PRINTER_PROFILES = 'SET_PRINTER_PROFILES';
export const UPSERT_PRINTER_PROFILE = 'UPSERT_PRINTER_PROFILE';
export const DELETE_PRINTER_PROFILE = 'DELETE_PRINTER_PROFILE';
export const SET_MODULE_PRINTER_PROFILE = 'SET_MODULE_PRINTER_PROFILE';
export const SET_MODULE_TEMPLATE = 'SET_MODULE_TEMPLATE';
export const SET_LABELER_MODULE_SETTINGS = 'SET_LABELER_MODULE_SETTINGS';
